import React from "react";
import { Button, Header, Image, List, Modal } from "semantic-ui-react";
import { TMapAuditingCheck } from "../IMapAuditing";
import { MapAdapter } from "../../../@tilannekuva/components/MapAdapter"
import { MapAuditingMarker } from "./MapAuditingMarker"
import Thumbnail from "../../../sg-fileupload/components/Thumbnail";
import { IMap } from "../../../@tilannekuva/models/Map";
import { useBool } from "../../../sg-hooks/useBool";
import { useTranslation } from "react-i18next";

interface MapAuditingListItemProps {
    title: string;
    itemData: TMapAuditingCheck;
    map: IMap
};

export const MapAuditingListItem: React.FC<MapAuditingListItemProps> = ({
    title,
    itemData,
    map
}) => {
    const t = useTranslation().t;
    const [open, showModal, hideModal] = useBool(false)

    const positionStr = `(tk=${map?.id})(x=${itemData.coordinates[0]})(y=${itemData.coordinates[1]})(z=5)`


    const mapTrigger = (
        <div style={{ height: "100%", cursor: "pointer" }} >
            <MapAdapter
                key={title}
                tilesetUrl={map.url}
                defaultPosition={positionStr}
                style={{ minHeight: 0, height: "100%" }}
                controls={false}
                scrollWheelZoom={false}
                doubleClickZoom={false}
                dragging={false}
            >
                <MapAuditingMarker
                    title={title}
                    checkItem={itemData}
                    interactive={false}
                />
            </MapAdapter>
        </div>
    );



    return (
        <List.Item
            className="MapAuditingListItem"
            key={title}
        >
            <div className="MapAuditingListItem-row">
                <div className="MapAuditingListItem-column map">
                    <Modal
                        open={open}
                        onClose={hideModal}
                        onOpen={showModal}
                        trigger={mapTrigger}
                        closeIcon
                    >
                        <div className="MapAuditingModal-map">
                            <MapAdapter
                                key={title}
                                tilesetUrl={map.url}
                                defaultPosition={positionStr}
                                style={{ minHeight: 0, height: "100%" }}
                            >
                                <MapAuditingMarker
                                    title={title}
                                    checkItem={itemData}
                                    interactive={false}
                                />
                            </MapAdapter>
                        </div>
                        <Modal.Actions>
                            <Button content={t("Sulje")} onClick={hideModal} style={{ width: "100%", marginLeft: 0 }} />
                        </Modal.Actions>
                    </Modal>
                </div>
                <div className="MapAuditingListItem-column content">
                    <Header size="small"> {title}  </Header>
                    <p>  {itemData.description} </p>

                    {(itemData.images?.length || 0) > 0 && (
                        <Image.Group className="AuditNoteItem-image-group">
                            {itemData.images?.map((imageId) => (
                                <Thumbnail
                                    key={imageId}
                                    className="AuditNoteItem-image"
                                    id={imageId}
                                    thumbnailWidth={100}
                                />
                            ))}
                        </Image.Group>
                    )}
                </div>
            </div>
        </List.Item>
    );
};
